/**
 * Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: LicenseRef-.amazon.com.-AmznSL-1.0
 * Licensed under the Amazon Software License  http://aws.amazon.com/asl/
 */

import React from 'react';
import { Button, Header as BaseHeader, Modal } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { makeObservable, observable, action, runInAction } from 'mobx';

import { SecureOutput } from '../../models/secure-outputs/SecureOutput';
import { displayError, displaySuccess } from '../../helpers/notification';
import { createForm } from '../../helpers/form';

import Form from '../helpers/fields/Form';

class ApproveEgress extends React.Component {
  modalOpen = false;

  constructor(props) {
    super(props);
    makeObservable(this, {
      modalOpen: observable,
    });

    this.secureOutput = props.secureOutput;
    this.permissionsStore = props.secureOutput.getPermissionsStore();
    this.cleanModal = this.cleanModal.bind(this);
    this.cleanModal();
  }

  cleanModal() {
    runInAction(() => {
      this.modalOpen = false;
    });
  }

  handleFormCancel = _form => {
    this.cleanModal();
  };

  handleFormError = (_form, _errors) => {};

  handleFormSubmission = async _form => {
    try {
      await this.permissionsStore.approveEgress(this.secureOutput.id);
      this.secureOutput.updateStatus(SecureOutput.MY_APPROVED);

      displaySuccess('Egress request approved.');
      this.cleanModal();
      if (this.props.onActionComplete) this.props.onActionComplete();	    
    } catch (error) {
      displayError(error);
    }
  };

  render() {
    const form = createForm({});
    return (
      <Modal closeIcon trigger={this.renderTrigger()} open={this.modalOpen} onClose={this.cleanModal}>
        <div className="mt2 animated fadeIn">
          <BaseHeader as="h3" icon textAlign="center" className="mt3" color="grey">
            Approve Egress
          </BaseHeader>
          <div className="mx3 animated fadeIn">
            <Form
              form={form}
              onCancel={this.handleFormCancel}
              onSuccess={this.handleFormSubmission}
              onError={this.handleFormError}
            >
              {({ processing, _onSubmit, onCancel }) => {
                return (
                  <>
                    Confirm egress approval?
                    <Button className="ml2 mb3" floated="right" color="blue" icon disabled={processing} type="submit">
                      Approve egress
                    </Button>
                    <Button className="mb3" floated="right" disabled={processing} onClick={onCancel}>
                      Cancel
                    </Button>
                  </>
                );
              }}
            </Form>
          </div>
        </div>
      </Modal>
    );
  }

  renderTrigger() {
    const props = this.props.buttonProps || {
      floated: 'right',
      size: 'mini',
      compact: true,
      color: 'blue',
    };
    return (
      <Button
        {...props}
        onClick={action(() => {
          this.modalOpen = true;
        })}
      >
        Approve egress
      </Button>
    );
  }
}

export default inject('userStore')(observer(ApproveEgress));
